import React, { useEffect } from 'react';
import { getUrlParam } from 'libs/helper/utils';
import { useStoreWrapper } from 'stores/StoreHelper';
import { useLocation } from 'react-router-dom';
import { AdminCouponDto, AdminUserCouponDto } from 'services/data-contracts';
import { observer } from 'mobx-react-lite';
import NoContents from 'components/commons/\bNoContents';
import CouponView from 'components/management/modals/CouponView';
import CouponEdit from 'components/management/modals/CouponEdit';
import UserCouponTable from 'components/management/tables/UserCouponTable';
import UserCouponFilter from 'components/management/filters/UserCouponFilter';
import ServiceHelper from 'stores/ServiceHelper';
import { toast } from 'react-toastify';
import { validationHelper } from 'controls/validationHelper';

const UserCouponPage = observer(() => {
  const { couponFilterStore, uiStore } = useStoreWrapper();

  const couponId = getUrlParam('couponId');
  const location = useLocation();

  const fetchUserCoupons = () => {
    const search = getUrlParam('searchKeyword');
    const page = getUrlParam('page');
    const size = getUrlParam('size');

    if (couponId) {
      couponFilterStore.getUserCoupons(parseInt(couponId), {
        keyword: search || '',
        page: page ? parseInt(page) : undefined,
        size: size ? parseInt(size) : 20,
      });
    }
  };

  const handleRowClick = (coupon: AdminUserCouponDto) => {
    uiStore?.modal.show({
      title: '쿠폰 상세',
      style: {
        maxWidth: '800px',
        height: 'auto',
        maxHeight: '80vh',
      },
      children: <CouponView rootCouponId={couponId ? parseInt(couponId) : 0} coupon={coupon} />,
      onClose: () => {
        fetchUserCoupons();
      },
    });
  };

  const handleEditClick = (quantity?: number) => {
    uiStore?.confirm.show({
      title: '사용자쿠폰 발행',
      message: `사용자 쿠폰 ${quantity}개를 발행하시겠습니까?`,
      onConfirmed: () => {
        ServiceHelper?.adminCouponService
          ?.createUserCoupons(couponId ? parseInt(couponId) : 0, { quantity: quantity as number })
          .then((res) => {
            toast.success('사용자쿠폰 발행이 완료되었습니다.');
            fetchUserCoupons();
          });
      },
    });
  };

  const handleDeleteClick = (userCoupon: AdminUserCouponDto) => {
    uiStore?.confirm.show({
      title: '사용자쿠폰 삭제',
      message: `사용자 쿠폰 ${userCoupon?.code}을 삭제하시겠습니까?`,
      onConfirmed: () => {
        ServiceHelper?.adminCouponService
          ?.deleteUserCoupon(couponId ? parseInt(couponId) : 0, userCoupon.id as number)
          .then((res) => {
            toast.success('사용자쿠폰 삭제가 완료되었습니다.');
            fetchUserCoupons();
          });
      },
    });
  };

  const handleUserEmailChange = (userCouponId: number, userEmail: string) => {
    if (couponId && parseInt(couponId) > 0) {
      if (!userEmail.trim()) {
        return;
      }

      if (!validationHelper.emailRegex(userEmail)) {
        toast.warning('이메일 형식이 올바르지 않습니다.');
        return;
      }

      ServiceHelper?.adminCouponService
        ?.assignUserCoupon(couponId ? parseInt(couponId) : 0, userCouponId, {
          username: userEmail,
        })
        .then((res) => {
          if (res.status === 200) {
            toast.success('사용자쿠폰 수정이 완료되었습니다.');
            fetchUserCoupons();
          } else if (res.status === 404) {
            toast.error('존재하지 않는 사용자 이메일입니다.');
          } else {
            toast.error('사용자쿠폰 수정에 실패했습니다.');
          }
          fetchUserCoupons();
        });
    }
  };

  useEffect(() => {
    fetchUserCoupons();
  }, [location.search]);

  return (
    <div>
      <UserCouponFilter onClickAdd={handleEditClick} />
      <UserCouponTable
        userCoupons={couponFilterStore?.filteredUserCoupons}
        onRowClick={handleRowClick}
        // onEditClick={handleEditClick}
        onDeleteClick={handleDeleteClick}
        onUserEmailChange={handleUserEmailChange}
      />
      <NoContents>표시할 데이터가 없습니다.</NoContents>
    </div>
  );
});

export default UserCouponPage;
